import React from 'react';
import { DiagramDisplayData } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Edit/InputData';
import { getSelectionDiagramsRect } from './DataDesignerUtils';
import { DndAdorner } from 'domains/designers/common';

export interface InputDataDndAdornerProps {
  diagrams: DiagramDisplayData[];
  expandedInputsIds: string[];
  left: number;
  top: number;
}

export function InputDataDndAdorner({ diagrams, expandedInputsIds, left, top }: InputDataDndAdornerProps) {
  const rect = getSelectionDiagramsRect(diagrams, expandedInputsIds);

  if (rect == null) {
    return null;
  }

  return (
    <DndAdorner zIndex={999} width={rect.width} height={rect.height} left={left} top={top}>
      <div className="dpc-data-designer__dnd-text">
        {diagrams.length === 1 ? diagrams[0].DataDescription.DisplayName : `${diagrams.length} diagrams`}
      </div>
    </DndAdorner>
  );
}
